"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAllAndRun = void 0;
function SelectAllAndRun(querySelector, callback) {
    const result = document.querySelectorAll(querySelector);
    if (result.length) {
        callback(result);
    }
}
exports.SelectAllAndRun = SelectAllAndRun;
